import { Col, Container, Row } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.svg";
import facelogo from "../assets/img/facelogo.png";
import { useEffect, useState } from "react";
import "animate.css";
import TrackVisibility from "react-on-screen";

const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  //I need a loop number that would be intially set to zero(that means start from 1st word). This loop number would indicate index where it is currently displayed on the screen
  const [isDeleting, setIsDeleting] = useState(false); //Initially false becuz we start by typing the word
  const toRotate = ["Web Developer", "Web Designer", "UI/UX Designer"]; //These are the words that i would like to be displayed
  const [text, setText] = useState(""); //The component needs to know what text we are showing right now
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(500);
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          {/* className="align-items-center--> This is a bootstrap styling class name. So when we add the relevant className, bootstrap will take care of the styling" */}
          <Col xs={12} md={6} xl={7}>
            {/* xs --> xtra small
            md --> medium
            xl --> xtra large */}
            <TrackVisibility>
              {(
                { isVisible } //Is visible is from TrackVisibility.
              ) => (
                //not from react.(make sure the remove the import that automatically comes when u type in isVisible)
                <div
                  className={
                    isVisible ? "animate__animated animate__pulse" : ""
                  } //These classnames u can obtain from https://animate.style/
                >
                  <span className="tagline">Welcome to my Portfolio</span>
                  <h1>
                    {`Hi I'm Yeran, I'm a `}
                    <span className="wrap">{text}</span>
                  </h1>
                  <p>Innovate.Create.Excel</p>
                  <button
                    onClick={() =>
                      (window.location.href =
                        "https://www.linkedin.com/in/yeran-kods/")
                    }
                  >
                    Let's connect <ArrowRightCircle size={25} />
                  </button>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <img src={facelogo} alt="Header Img" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Banner;

//commit check1
